module.exports = __webpack_public_path__ + "img/nest-1.13c0beaa.png";